import { Phone, MessageSquare } from "lucide-react";
import { telLink, smsLink } from "@/data/site";

// Sticky bottom CTA bar for mobile — always-accessible Call / Text actions.
export default function MobileCTABar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 grid grid-cols-2 gap-2 border-t border-border bg-cream/95 p-2.5 backdrop-blur lg:hidden" data-testid="mobile-cta-bar">
      <a href={telLink} data-testid="mobile-call" className="flex items-center justify-center gap-2 rounded-md bg-gold py-3.5 text-sm font-bold text-charcoal active:scale-[0.98]">
        <Phone className="h-4 w-4" strokeWidth={2.4} /> Call Now
      </a>
      <a href={smsLink} data-testid="mobile-text" className="flex items-center justify-center gap-2 rounded-md bg-forest py-3.5 text-sm font-bold text-cream active:scale-[0.98]">
        <MessageSquare className="h-4 w-4" strokeWidth={2.4} /> Text Us
      </a>
    </div>
  );
}
